import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'mobx-react';
import store from './stores/index';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';
import styled from 'styled-components';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import ReactGA from 'react-ga4';

const GOOGLE_ANALYTICS_CODE = process.env.REACT_APP_GOOGLE_ANALYTICS;
ReactGA.initialize(GOOGLE_ANALYTICS_CODE);

const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
`;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider AppStore={store}>
        <AppWrapper>
          <App />
        </AppWrapper>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
